import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["onButtonClick", "userInfo", "subscriptionId", "onSuccess", "onError", "size", "use", "errorButtonText", "isHubDelinquent"];
import FormattedMessage from 'I18n/components/FormattedMessage';
import { registerMutation, useMutation } from 'data-fetching-client';
import { getDataFetchingClient } from '../../clients/dataFetchingClient';
import { httpClientWithRaven } from '../../clients/hubHttpWithRaven';
import FintechOutagesCheckTooltip from '../FintechOutages/FintechOutagesCheckTooltip';
import { BILLING_ADMIN_ROLE } from '../../constants/roles.constants';
import HubDelinquentTooltip from '../HubDelinquentTooltip/HubDelinquentTooltip';
import { LoadingButton } from 'foundations-components/transitional/components/LoadingButton';
import { jsx as _jsx } from "react/jsx-runtime";
const TURN_AUTO_RENEWAL_ON_MUTATION = registerMutation({
  fieldName: 'turnAutoRenewalOnInfo',
  args: ['subscriptionId'],
  fetcher({
    subscriptionId
  }) {
    return httpClientWithRaven.delete(`/billing-management/v2/cancellation/subscription/${subscriptionId}`, {
      ravenOptions: {
        message: 'Error turning auto-renewal on'
      }
    });
  }
});
export const TurnAutoRenewalOnButton = _ref => {
  let {
      onButtonClick,
      userInfo,
      subscriptionId,
      onSuccess,
      onError,
      size = 'small',
      use = 'tertiary-light',
      errorButtonText,
      isHubDelinquent
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const [turnAutoRenewalOn, {
    loading: turnAutoRenewalOnMutationLoading,
    error
  }] = useMutation(TURN_AUTO_RENEWAL_ON_MUTATION, {
    variables: {
      subscriptionId
    },
    onCompleted() {
      if (onSuccess) onSuccess();
    },
    onError: () => {
      if (onError) onError();
    },
    client: getDataFetchingClient()
  });
  const disabled = rest.disabled || isHubDelinquent;
  const onClick = event => {
    if (onButtonClick) onButtonClick();
    turnAutoRenewalOn().catch(() => {
      // Do nothing
    });
    event.stopPropagation();
  };
  return /*#__PURE__*/_jsx(FintechOutagesCheckTooltip, {
    rolesToAuthorize: [BILLING_ADMIN_ROLE],
    requiresZuoraAvailability: true,
    userInfo: userInfo,
    DefaultTooltipComponent: isHubDelinquent ? HubDelinquentTooltip : undefined,
    children: /*#__PURE__*/_jsx(LoadingButton, Object.assign({}, rest, {
      disabled: disabled,
      failed: !!error,
      loading: turnAutoRenewalOnMutationLoading,
      size: size,
      "data-test-id": "batch-turn-auto-renewal-on-btn",
      onClick: onClick,
      use: use,
      children: errorButtonText && error ? errorButtonText : /*#__PURE__*/_jsx(FormattedMessage, {
        message: "account-and-billing-components.TurnAutoRenewalOnButton.turn-auto-renewal-on-button-text"
      })
    }))
  });
};